"use strict";
// We are using 'use strict' and module.exports to ensure this file is compatible
// with the Node.js environment of the seeding script.
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialPois = void 0;
exports.initialPois = [
    {
        id: '1',
        name: 'Lakemba Mosque',
        type: 'prayer_area',
        lat: -33.9126312,
        lng: 151.0741113,
        address: '65-67 Wangee Rd, Lakemba NSW 2195, Australia',
        prayer_space_size: 'Large, accommodates over 1000 people',
        hours: 'Open for all daily prayers',
    },
    {
        id: '2',
        name: 'El-Manara Restaurant',
        type: 'restaurant',
        lat: -33.9194703,
        lng: 151.0759197,
        address: '45 Railway Pde, Lakemba NSW 2195, Australia',
        halal_certification: 'Certified by the Halal Certification Authority Australia',
        hours: 'Mon-Sun: 11:00 AM - 10:00 PM',
    },
    {
        id: '3',
        name: 'Iqra Books',
        type: 'business',
        lat: -33.9195053,
        lng: 151.0758457,
        address: 'Shop 2/47 Railway Pde, Lakemba NSW 2195, Australia',
        augmentedInformation: 'Specializes in Islamic books, clothing, and gifts.',
        hours: 'Mon-Sat: 10:00 AM - 6:00 PM',
    },
    {
        id: '4',
        name: 'Gallipoli Mosque',
        type: 'prayer_area',
        lat: -33.8560142,
        lng: 151.0230432,
        address: '15-19 North Parade, Auburn NSW 2144, Australia',
        hours: 'Open for all daily prayers',
    },
    {
        id: '5',
        name: 'Jasmin1',
        type: 'restaurant',
        lat: -33.9259214,
        lng: 151.0565932,
        address: '224 The Boulevarde, Punchbowl NSW 2196, Australia',
        hours: 'Mon-Sun: 10:00 AM - 10:00 PM',
    },
    {
        id: '6',
        name: 'Kuraby Masjid (Al-Farooq)',
        type: 'prayer_area',
        lat: -27.6057782,
        lng: 153.0933689,
        address: '1408 Beenleigh Rd, Kuraby QLD 4112, Australia',
        prayer_space_size: 'Accommodates over 500 people, separate womens section',
        augmentedInformation: 'Full mosque facilities, holds regular Jummah prayers and classes.',
        hours: 'Open for all daily prayers',
    },
    {
        id: '7',
        name: 'Mazaar Charcoal Chicken',
        type: 'restaurant',
        lat: -27.6396346,
        lng: 153.1266005,
        address: '3/1-5, Albert St, Slacks Creek QLD 4127, Australia',
        halal_certification: 'Self-certified, 100% halal menu',
        hours: 'Mon-Sun: 11:00 AM - 9:00 PM',
    },
    {
        id: '8',
        name: 'All-Huda Islamic Centre',
        type: 'prayer_area',
        lat: -27.6396346,
        lng: 153.1266005,
        address: '34-36 Service Rd, Slacks Creek QLD 4127, Australia',
        hours: 'Open for all daily prayers',
    },
    {
        id: '10',
        name: 'Bismillah Kebabs & Pizza',
        type: 'restaurant',
        lat: -27.5836454,
        lng: 153.0623511,
        address: '3/95 Mains Rd, Underwood QLD 4110, Australia',
        hours: 'Mon-Sun: 10:30 AM - 9:30 PM',
    },
    {
        id: '11',
        name: 'Islamic College of Brisbane',
        type: 'prayer_area',
        lat: -27.6187818,
        lng: 153.0919149,
        address: '45 Acacia Rd, Karawatha, Brisbane QLD 4117, Australia',
        augmentedInformation: 'Provides prayer facilities for students and staff.',
        hours: 'School hours; contact for details',
    },
    {
        id: '12',
        name: 'Melbourne Grand Mosque',
        type: 'prayer_area',
        lat: -37.8117935,
        lng: 144.9514183,
        address: '66-76 Jeffcott St, West Melbourne VIC 3003, Australia',
        prayer_space_size: 'Large capacity, youth programs available',
        hours: 'Open for all daily prayers',
    },
    {
        id: '13',
        name: "Omar's Kitchen",
        type: 'restaurant',
        lat: -37.7540208,
        lng: 144.9642166,
        address: '55-57 Sydney Rd, Coburg, Melbourne VIC 3058, Australia',
        halal_certification: 'Certified Halal',
        hours: 'Tue-Sun: 12:00 PM - 9:00 PM',
    },
    {
        id: '14',
        name: 'Queen Victoria Market Prayer Room',
        type: 'prayer_area',
        lat: -37.8127603,
        lng: 144.9597505,
        address: 'Queen St, Melbourne VIC 3000, Australia',
        augmentedInformation: 'Small multi-faith room available for prayers within the market.',
        hours: 'Market hours: Tue, Thu, Fri: 6am-3pm; Sat: 6am-4pm; Sun: 9am-4pm',
    },
    {
        id: '15',
        name: 'Melbourne Madinah',
        type: 'business',
        lat: -37.8166272,
        lng: 144.9587239,
        address: '472 Little Collins St, Melbourne VIC 3000, Australia',
        augmentedInformation: 'Sells Islamic books, art, and fragrances.',
        hours: 'Mon-Fri: 11:00 AM - 7:00 PM; Sat: 12:00 PM - 5:00 PM',
    },
    {
        id: '16',
        name: 'Zaikaa',
        type: 'restaurant',
        lat: -27.6086545,
        lng: 153.110024,
        address: 'C/21 Kingston Road, Underwood QLD 4119',
        hours: 'Mon-Sun: 5:00 PM - 10:00 PM',
    },
    {
        id: '17',
        name: 'Virsa Restaurant',
        type: 'restaurant',
        lat: -27.6080364,
        lng: 153.1125776,
        address: 'Shop 5, 2922–2926 Logan Road, Underwood QLD 4119',
        hours: 'Tue-Sun: 11:30 AM - 9:30 PM',
    },
    {
        id: '18',
        name: 'Mangal Char Grill',
        type: 'restaurant',
        lat: -27.607058,
        lng: 153.10993,
        address: 'Underwood Market Place, 3215 Logan Road, Underwood QLD 4119',
        hours: 'Mon-Sun: 10:00 AM - 9:00 PM',
    },
    {
        id: '19',
        name: 'Tanveer’s Curry Hut',
        type: 'restaurant',
        lat: -27.6056939,
        lng: 153.1109673,
        address: '2892 Logan Road, Underwood QLD 4119',
        hours: 'Mon-Sun: 11:00 AM - 10:00 PM',
    },
    {
        id: '20',
        name: 'Bufwin - Chicken Buffet',
        type: 'restaurant',
        lat: -27.6080364,
        lng: 153.1125776,
        address: '2922–2926 Logan Road, Underwood QLD 4119',
        hours: 'Mon-Sun: 11:30 AM - 10:00 PM',
    },
    {
        id: '21',
        name: 'SILK ROAD Xinjiang Cuisine',
        type: 'restaurant',
        lat: -27.6080364,
        lng: 153.1125776,
        address: 'Shop 2, 2922–2926 Logan Road, Underwood QLD 4119',
        hours: 'Mon-Sun: 11:00 AM - 9:00 PM',
    },
    {
        id: '22',
        name: 'The Lane Restaurant',
        type: 'restaurant',
        lat: -27.6057452,
        lng: 153.1110471,
        address: '2892-2896 Logan Road, Underwood QLD 4119',
        hours: 'Mon-Sun: 7:00 AM - 9:00 PM',
    },
    {
        id: '23',
        name: 'Rashays Underwood',
        type: 'restaurant',
        lat: -27.6057451,
        lng: 153.111047,
        address: 'Shop 5, 2892 Logan Rd, Underwood QLD 4119',
        hours: 'Mon-Sun: 9:00 AM - 10:00 PM',
    },
    {
        id: '24',
        name: 'Mi Casa Café',
        type: 'restaurant',
        lat: -27.6097482,
        lng: 153.1131861,
        address: 'Unit 4/3245 Logan Rd, Underwood QLD 4119',
        hours: 'Mon-Sat: 7:00 AM - 4:00 PM',
    },
    {
        id: '25',
        name: 'Manok Park',
        type: 'restaurant',
        lat: -27.6087042,
        lng: 153.110084,
        address: 'Shop 18, 11–21 Kingston Rd, Underwood QLD 4119',
        augmentedInformation: 'Korean cuisine (bibimbap, spicy chicken, sides)',
        hours: 'Tue-Sun: 11:00 AM - 9:00 PM',
    },
    {
        id: '26',
        name: 'Ming Chinese Restaurant',
        type: 'restaurant',
        lat: -27.6061728,
        lng: 153.1112544,
        address: 'Shop 1, 2898 Logan Rd, Underwood QLD 4119',
        augmentedInformation: 'Yum cha, Chinese dishes, dim sum',
        hours: 'Mon-Sun: 10:00 AM - 3:00 PM, 5:00 PM - 9:00 PM',
    },
    {
        id: '27',
        name: 'Daega Korean BBQ',
        type: 'restaurant',
        lat: -27.6080364,
        lng: 153.1125776,
        address: '2926 Logan Rd, Underwood QLD 4119',
        augmentedInformation: 'Korean BBQ, grilled meats, banchan (side dishes)',
        hours: 'Mon-Sun: 5:00 PM - 11:00 PM',
    },
    {
        id: '28',
        name: 'Pu Kwong Vegetarian Restaurant',
        type: 'restaurant',
        lat: -27.5962552,
        lng: 153.1087141,
        address: '2796 Logan Rd, Underwood QLD 4119',
        augmentedInformation: 'Vegetarian Chinese, vegan-friendly',
        hours: 'Wed-Mon: 11:00 AM - 8:30 PM',
    },
    {
        id: '29',
        name: 'Zambeekas Restaurant',
        type: 'restaurant',
        lat: -27.6093594,
        lng: 153.1111772,
        address: 'Shop 1/19 Kingston Rd, Underwood QLD 4119',
        augmentedInformation: 'Portuguese/Mediterranean grills',
        hours: 'Mon-Sun: 11:00 AM - 9:00 PM',
    },
    {
        id: '30',
        name: 'Espressgo Café',
        type: 'restaurant',
        lat: -27.6135019,
        lng: 153.1206859,
        address: '2994 Logan Rd, Underwood QLD 4119',
        augmentedInformation: 'Coffee, brunch, smoothies, toasties',
        hours: 'Mon-Fri: 6:00 AM - 3:00 PM',
    },
    {
        id: '31',
        name: 'Fresh Bun Café',
        type: 'restaurant',
        lat: -27.6187237,
        lng: 153.1109687,
        address: 'Shop 3, 39 Compton Rd, Underwood QLD 4119',
        augmentedInformation: 'Casual eats, burgers, breakfast, wraps',
        hours: 'Mon-Sat: 7:00 AM - 3:00 PM',
    },
    {
        id: '33',
        name: 'The Fishmonger\'s Wife (Underwood)',
        type: 'restaurant',
        lat: -27.6057326,
        lng: 153.111053,
        address: 'Shop 4, 2892 Logan Rd, Underwood QLD 4119',
        augmentedInformation: 'Seafood and grill, fish &amp; chips, burgers',
        hours: 'Mon-Sun: 11:00 AM - 8:00 PM',
    },
    {
        id: '34',
        name: 'Kravings',
        type: 'restaurant',
        lat: -27.6102115,
        lng: 153.114209,
        address: '1/3282 Logan Rd, Underwood QLD 4119',
        augmentedInformation: 'Malaysian and Indian fusion cuisine',
        hours: 'Tue-Sun: 10:00 AM - 8:00 PM',
    },
    {
        id: '35',
        name: 'Kumo Izakaya',
        type: 'restaurant',
        lat: -27.6087042,
        lng: 153.110084,
        address: 'Shop 2, 11–21 Kingston Rd, Underwood QLD 4119',
        augmentedInformation: 'Japanese street food and small plates',
        hours: 'Tue-Sun: 5:00 PM - 10:00 PM',
    },
    {
        id: '36',
        name: 'Academy Alive Musallah',
        type: 'prayer_area',
        lat: -27.6108346,
        lng: 153.113981,
        address: '3 Ferguson St, Underwood QLD 4119',
        augmentedInformation: 'Wudhū facilities available for men and women. Daily salah held.',
        hours: 'Open for daily prayers',
    },
    {
        id: '37',
        name: 'Brisbane Islamic Centre',
        type: 'prayer_area',
        lat: -27.5916745,
        lng: 153.0932999,
        address: '161 Underwood Rd, Eight Mile Plains QLD 4113',
        augmentedInformation: 'Sunni centre that holds Jummah prayers and offers educational classes.',
        hours: 'Open for daily prayers',
    },
    {
        id: '38',
        name: 'United Muslims of Brisbane',
        type: 'prayer_area',
        lat: -27.63891,
        lng: 153.106899,
        address: '8 Blackwood Rd, Logan Central QLD 4114',
        augmentedInformation: 'Full mosque facilities, Jummah prayers, and regular youth events.',
        hours: 'Open for daily prayers',
    },
    {
        id: '39',
        name: 'Iqra Academy Australia',
        type: 'business',
        lat: -27.6494056,
        lng: 153.1205171,
        address: '16 Queens Rd, Slacks Creek Queensland 4127',
        augmentedInformation: 'Educational institution.',
        hours: 'Mon-Fri: 9:00 AM - 5:00 PM',
    },
    {
        id: '40',
        name: 'Slacks Creek Mosque',
        type: 'prayer_area',
        lat: -27.6494056,
        lng: 153.1205171,
        address: '16 Queens Road, Slacks Creek Queensland 4127',
        hours: 'Open for daily prayers',
    },
    {
        id: '41',
        name: 'Mandi Al Arabia / Baalbek',
        type: 'restaurant',
        lat: -27.6298631,
        lng: 153.1188721,
        address: 'Shop 10, 250 Kingston Rd, Slacks Creek QLD 4127, Australia',
        augmentedInformation: 'Lebanese / Middle Eastern Cuisine',
        hours: 'Mon-Sun: 10:00 AM - 10:00 PM',
    },
    {
        id: '42',
        name: 'Charcoal Kebab',
        type: 'restaurant',
        lat: -27.6441151,
        lng: 153.1196409,
        address: '382–390 Kingston Rd, Slacks Creek QLD 4127, Australia',
        augmentedInformation: 'Afghan kebabs &amp; grill',
        hours: 'Mon-Sun: 11:00 AM - 9:00 PM',
    },
    {
        id: '43',
        name: 'Shahi Nan Kebab',
        type: 'restaurant',
        lat: -27.6301368,
        lng: 153.1190647,
        address: '2/254 Kingston Rd, Slacks Creek QLD 4127, Australia',
        augmentedInformation: 'Afghan fast food',
        hours: 'Mon-Sun: 11:00 AM - 10:00 PM',
    },
    {
        id: '44',
        name: 'Oishi Teppanyaki &amp; Café',
        type: 'restaurant',
        lat: -27.6263695,
        lng: 153.1180427,
        address: 'Shop 1, 214 Kingston Rd, Slacks Creek QLD 4127, Australia',
        augmentedInformation: 'Japanese halal Teppanyaki',
        hours: 'Tue-Sun: 5:00 PM - 9:30 PM',
    },
    {
        id: '45',
        name: 'ZamZam Restaurant',
        type: 'restaurant',
        lat: -27.6265523,
        lng: 153.1181025,
        address: 'Shop 3, 208–214 Kingston Rd, Slacks Creek QLD 4127, Australia',
        augmentedInformation: 'Pakistani / Afghani cuisine',
        hours: 'Mon-Sun: 11:00 AM - 10:00 PM',
    },
    {
        id: '46',
        name: 'Amin’s Halal Butcher &amp; Grill',
        type: 'business',
        lat: -27.6124377,
        lng: 153.1240137,
        address: 'Shop 25 &amp; 26A, 17–27 Cinderella Dr, Slacks Creek QLD 4127, Australia',
        augmentedInformation: 'Halal grill &amp; butcher',
        hours: 'Mon-Sun: 8:00 AM - 7:00 PM',
    },
    {
        id: '47',
        name: 'Smashhh Burgers (Underwood)',
        type: 'restaurant',
        lat: -27.6104612,
        lng: 153.1138891,
        address: '3261 Logan Road, Underwood QLD 4119, Australia',
        augmentedInformation: 'Gourmet smash burgers',
        hours: 'Re-opening in 2026',
        isPartner: true,
    },
    {
        id: '48',
        name: 'Hungry Jacks',
        type: 'restaurant',
        lat: -27.5576681,
        lng: 153.0419625,
        address: '19 Kessels Rd, Nathan QLD 4111, Australia',
        augmentedInformation: 'Fast food chain for burgers &amp; fries.',
        hours: 'Open 24 hours',
    },
    {
        id: '49',
        name: 'Darussalam Islamic Bookstore Lakemba',
        type: 'business',
        lat: -33.9222765,
        lng: 151.0786224,
        address: '149 Haldon St, Lakemba NSW 2195, Australia',
        augmentedInformation: 'Sells a wide range of Islamic books, perfumes, and clothing.',
        hours: 'Mon-Sun: 10:00 AM - 8:00 PM',
    },
    {
        id: '50',
        name: 'LouLan Halal Restaurant',
        type: 'restaurant',
        lat: -27.5907071,
        lng: 153.0652473,
        address: 'Shop T1&amp;T2, 22 Gowan Rd, Sunnybank Hills QLD 4113, Australia',
        augmentedInformation: 'Specializes in authentic Uyghur and Central Asian halal cuisine, known for hand-pulled noodles.',
        hours: 'Mon-Sun: 11:00 AM - 9:00 PM',
    },
    {
        id: '51',
        name: 'Fatty Patty',
        type: 'restaurant',
        lat: -27.6092593,
        lng: 153.1119105,
        address: 'Underwood, QLD 4119 (Mobile Burger Truck)',
        augmentedInformation: 'Mobile burger truck, location may vary. Check social media for current location.',
        hours: 'Check social media for hours',
    },
    {
        id: '52',
        name: 'Taco Joint',
        type: 'restaurant',
        lat: -27.6085711,
        lng: 153.1131486,
        address: 'Unit 1/2932 Logan Rd, Underwood QLD 4119, Australia',
        hours: 'Tue-Sun: 12:00 PM - 9:00 PM',
    },
    {
        id: '53',
        name: 'Sam’s Gourmet Pizzas &amp; Manoush',
        type: 'restaurant',
        lat: -27.6070516,
        lng: 153.1099377,
        address: 'Shop 44, 3215 Logan Rd, Underwood QLD 4119, Australia',
        hours: 'Mon-Sun: 10:00 AM - 10:00 PM',
    },
    {
        id: '54',
        name: 'Sunshine Kebabs',
        type: 'restaurant',
        lat: -27.6096007,
        lng: 153.1126038,
        address: 'Shop 6, 3231 Logan Rd, Underwood QLD 4119, Australia',
        hours: 'Mon-Sun: 10:00 AM - 11:00 PM',
    },
    {
        id: '55',
        name: 'Lahori Cuisine',
        type: 'restaurant',
        lat: -27.9851047,
        lng: 153.397261,
        address: '3/29 Coolibah St, Southport QLD 4215, Australia',
        augmentedInformation: 'Pakistani dishes – rich, traditional halal menu',
        hours: 'Mon-Sun: 11:30 AM - 9:30 PM',
    },
    {
        id: '56',
        name: 'Gad’s Grill House',
        type: 'restaurant',
        lat: -27.5606844,
        lng: 153.0832636,
        address: 'Shop 13, 2120 Logan Rd, Upper Mount Gravatt QLD 4122, Australia',
        augmentedInformation: 'Mediterranean/Middle Eastern grill in Brisbane',
        hours: 'Mon-Sun: 11:00 AM - 9:00 PM',
    },
    {
        id: '57',
        name: 'Booza Bliss',
        type: 'restaurant',
        lat: -27.6063115,
        lng: 153.0941441,
        address: 'Kuraby, QLD 4112, Australia',
        augmentedInformation: 'Popular for its stretchy, traditional Middle Eastern ice cream. Note: This is a general location in Kuraby as a specific address was not provided.',
        hours: 'Check social media for hours',
    },
    {
        id: '58',
        name: 'Brisbane CBD Musallah (Albert St)',
        type: 'prayer_area',
        lat: -27.471099,
        lng: 153.0260545,
        address: '1/138 Albert Street, Brisbane City QLD 4000',
        augmentedInformation: 'Open Mon–Fri 7 AM–6 PM; Jummah prayers available; access card needed after hours',
        hours: 'Mon–Fri: 7:00 AM - 6:00 PM',
    },
    {
        id: '59',
        name: 'QUT Muslim Prayer Room (Gardens Point)',
        type: 'prayer_area',
        lat: -27.476109,
        lng: 153.027737,
        address: 'G-H Block Link, Gardens Point, Brisbane City QLD 4000',
        augmentedInformation: 'Includes wudu &amp; women’s prayer area; closed during uni semester breaks',
        hours: 'Open during university hours',
    },
    {
        id: '61',
        name: 'Sayram',
        type: 'restaurant',
        lat: -27.480776,
        lng: 153.0226283,
        address: '199 Grey St, South Brisbane QLD 4101, Australia',
        augmentedInformation: 'Specializes in authentic Uyghur cuisine.',
        hours: 'Mon-Sun: 11:30 AM - 9:30 PM',
    },
    {
        id: '62',
        name: '2 Bros Nashville Hot Chicken – Underwood',
        type: 'restaurant',
        lat: -27.6065365,
        lng: 153.1094776,
        address: '3215 Logan Rd, Underwood QLD 4119',
        hours: 'Mon-Sun: 10:00 AM - 10:00 PM',
    },
    {
        id: '63',
        name: '2 Bros Nashville Hot Chicken – Slacks Creek',
        type: 'restaurant',
        lat: -27.6255679,
        lng: 153.1174905,
        address: '200 Kingston Rd, Slacks Creek QLD 4127',
        hours: 'Mon-Sun: 10:00 AM - 10:00 PM',
    },
    {
        id: '64',
        name: '2 Bros Nashville Hot Chicken – Parkwood',
        type: 'restaurant',
        lat: -27.9562745,
        lng: 153.366094,
        address: 'Parkwood, Gold Coast, QLD',
        hours: 'Mon-Sun: 10:00 AM - 10:00 PM',
    },
    {
        id: '65',
        name: 'Big Buns – Browns Plains',
        type: 'restaurant',
        lat: -27.6615407,
        lng: 153.0428988,
        address: 'Shop 5A, 111–121 Grand Plaza Drive, Browns Plains QLD 4118',
        hours: 'Mon-Sun: 10:00 AM - 10:00 PM',
        isPartner: true,
    },
    {
        id: '66',
        name: 'Big Buns – Upper Mount Gravatt',
        type: 'restaurant',
        lat: -27.557964,
        lng: 153.0807244,
        address: 'Shop 31, The Village (1932 Logan Road), Mount Gravatt QLD 4122',
        hours: 'Mon-Sun: 10:00 AM - 10:00 PM',
        isPartner: true,
    },
    {
        id: '67',
        name: 'Curry Express',
        type: 'restaurant',
        lat: -27.9337481,
        lng: 153.3908824,
        address: '14/620 Oxley Dr, Biggera Waters QLD 4216, Australia',
        halal_certification: '100% Halal',
        augmentedInformation: 'Indian/Pakistani cuisine',
    },
    {
        id: '68',
        name: 'Baba Joon Persian Grill',
        type: 'restaurant',
        lat: -28.0038435,
        lng: 153.4285568,
        address: '3106 Surfers Paradise Blvd, Surfers Paradise QLD 4217, Australia',
        halal_certification: 'Halal',
        augmentedInformation: 'Persian cuisine',
    },
    {
        id: '69',
        name: 'Sultans Middle Eastern Grill',
        type: 'restaurant',
        lat: -27.930886,
        lng: 153.3878742,
        address: 'Harbour Town Premium Outlets, 147–189 Brisbane Road, Biggera Waters QLD 4216',
        hours: 'Mon-Sun: 11:00 AM - 9:45 PM',
        augmentedInformation: 'Middle Eastern cuisine',
    },
    {
        id: '70',
        name: 'Hunky Dunky Delights',
        type: 'business',
        lat: -27.4704528,
        lng: 153.0260341,
        address: 'Brisbane, QLD',
        augmentedInformation: 'Home bakery offering fresh, delicious cookies, donuts, brownies, and cupcakes customised just the way you like for any event or special occasion. Sweet treats, made to match your moments!',
    },
    {
        id: '71',
        name: 'Baba Kumpir',
        type: 'restaurant',
        lat: -27.6102495,
        lng: 153.1135696,
        address: '3257 Logan Rd, Underwood QLD 4119, Australia',
        isPartner: true,
        augmentedInformation: "Brisbane’s first Turkish baked potatoes. Specializes in Turkish-style baked potatoes (kumpir) with a variety of toppings.",
        hours: 'Friday - Sunday 6:30pm - 10:30pm',
    },
    {
        id: '72',
        name: 'Piebrothers',
        type: 'restaurant',
        lat: -33.8823,
        lng: 151.0116,
        address: '327 Woodville Rd, Guildford NSW 2160, Australia',
        halal_certification: '100% Halal-Hand Slaughtered',
        augmentedInformation: '🥧 Made For Family, Now Made for You',
    },
    {
        id: '73',
        name: "Tuya's By Tuya Taste",
        type: 'restaurant',
        lat: -27.6080364,
        lng: 153.1125776,
        address: '2922-2926 Logan Road, Underwood QLD 4119, Australia',
    }
];
